module.exports = __webpack_public_path__ + "img/1367901538.7dcea96f.jpg";